import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getAffiliatePartner, listAffiliatePartners } from "./api";
import type {
  AffiliatePartner,
  ListAffiliatePartnersQuery,
  PaginatedAffiliatePartners,
} from "./types";

export const AffiliatePartnersKeys = {
  all: ["affiliate-partners"] as const,
  list: (query: ListAffiliatePartnersQuery = {}) =>
    ["affiliate-partners", "list", query] as const,
  detail: (id: number | string) =>
    ["affiliate-partners", "detail", String(id)] as const,
};

export function useAffiliatePartners(query: ListAffiliatePartnersQuery = {}) {
  return useQuery<PaginatedAffiliatePartners, Error>({
    queryKey: AffiliatePartnersKeys.list(query),
    queryFn: () => listAffiliatePartners(query),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
    gcTime: 5 * 60_000,
  });
}

export function useAffiliatePartner(id: number | string | null | undefined) {
  const enabled = id !== null && id !== undefined && id !== "";

  return useQuery<AffiliatePartner, Error>({
    queryKey: enabled
      ? AffiliatePartnersKeys.detail(id as number | string)
      : ["affiliate-partners", "detail", "disabled"],
    queryFn: () => getAffiliatePartner(id as number | string),
    enabled,
    staleTime: 60_000,
    gcTime: 10 * 60_000,
  });
}
